module.exports = __webpack_public_path__ + "img/tchize-dos-santos.9a39eccb.png";